import type {
  StaffGetContractSettlementResponse,
  StaffUpdateContractSettlementRequest,
  UploadedDocument,
} from '@urbanx/agx.campaigns.client';
import { dateOnlyToDate } from '@urbanx/agx.ui-components2';

export type SettlementFileValue = UploadedDocument | File;

export const getInitialSettlementDate = (
  actualSettlementDate?: StaffGetContractSettlementResponse['actualSettlementDate']
): Date => dateOnlyToDate(actualSettlementDate) ?? new Date();

const isFile = (value: SettlementFileValue | undefined): value is File =>
  typeof File !== 'undefined' && value instanceof File;

export const hasDocumentSelectionChanged = (
  selectedDocuments: SettlementFileValue[],
  originalDocuments: UploadedDocument[]
): boolean =>
  selectedDocuments.length !== originalDocuments.length ||
  selectedDocuments.some(
    (document, index) =>
      isFile(document) || document.containerFilePath !== originalDocuments[index]?.containerFilePath
  );

export const buildSettlementContractDocuments = ({
  vendorConfirmation,
  buyerConfirmation,
  pexaConfirmations,
  additionalSettlementCorrespondence,
}: {
  vendorConfirmation?: UploadedDocument;
  buyerConfirmation?: UploadedDocument;
  pexaConfirmations: UploadedDocument[];
  additionalSettlementCorrespondence: UploadedDocument[];
}): StaffUpdateContractSettlementRequest['contractDocuments'] => ({
  vendorSettlementConfirmation: vendorConfirmation,
  buyerSettlementConfirmation: buyerConfirmation,
  pexaSettlementConfirmation: pexaConfirmations[0],
  pexaSettlementConfirmations: pexaConfirmations,
  additionalSettlementCorrespondence,
});
